import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { LoadingFullScreen } from '/imports/ui/LoadingFullScreen';
import { handleEnphaseAccessTokenCode } from '/imports/api/enphaseMeters';
import { strings } from '/imports/strings';

const EnphaseRedirectPageStyled = styled.div`
`;

/**
 * Handles the Enphase OAuth redirect, exchanging the code for an access token.
 */
export const EnphaseRedirectPage = () => {
  const [loading, setLoading] = useState(true);
  const params = new URLSearchParams(location.search);
  const code = params.get('code');
  const state = JSON.parse(window.atob(params.get('state') || ''));
  const error = params.get('error');
  const { orgId, username } = state;
  useEffect(() => {
    if (code && orgId) {
      (async () => {
        await handleEnphaseAccessTokenCode.call({ code, orgId, username });
        setLoading(false);
      })();
    }
    else if (error) {
      console.log(error);
      toast.error(`${error}`);
    }
  }, []);
  if (loading) {
    return (
      <EnphaseRedirectPageStyled className="page">
        <LoadingFullScreen />
      </EnphaseRedirectPageStyled>
    );
  }
  return (
    <EnphaseRedirectPageStyled className="page">
      {strings.ThankYouForConnectingYourAccountToLuminia()}
    </EnphaseRedirectPageStyled>
  );
};